import {
  Block,
  LabelMedium,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

type ManageSetupItemProps = {
  title: string
  subTitle?: string
  value: string
  subValue?: string
  description?: string
}

export default function ManageSetupItem({
  title,
  subTitle,
  value,
  subValue,
  description,
}: ManageSetupItemProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        marginRight: theme.sizing.scale600,
      })}
    >
      <Block
        className={css({
          paddingLeft: theme.sizing.scale600,
          marginBottom: theme.sizing.scale100,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        })}
      >
        <LabelMedium>{title}</LabelMedium>
        <LabelMedium>{value}</LabelMedium>
      </Block>
      <Block
        className={css({
          paddingLeft: theme.sizing.scale600,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          minHeight: theme.sizing.scale700,
        })}
      >
        {subTitle && (
          <ParagraphSmall color={theme.colors.contentSecondary}>
            {subTitle}
          </ParagraphSmall>
        )}
        {subValue && (
          <ParagraphSmall color={theme.colors.contentSecondary}>
            {subValue}
          </ParagraphSmall>
        )}
      </Block>
      {description && (
        <ParagraphSmall
          color={theme.colors.contentSecondary}
          paddingLeft={theme.sizing.scale600}
        >
          {description}
        </ParagraphSmall>
      )}
    </Block>
  )
}
